module.exports = __webpack_public_path__ + "img/9-2.cfb71648.jpg";